import React from 'react';
import { ChevronRightIcon } from '@qualtrics/ui-react/icons';
import styles from './navigation.scss';
import PropTypes from 'prop-types';
import { highlightSearch } from '../../highlighters/highlightSearch';

export const NavigationLabel = ({
  superTab,
  sectionTab,
  subTab,
  searchString,
}) => {
  const labels = [superTab.name, sectionTab?.name, subTab?.name].filter(
    (label) => label !== undefined,
  );
  const labelsWithLastLabelHighlighted = labels.map((label, index) => {
    return index === labels.length - 1
      ? highlightSearch(label, searchString)
      : label;
  });

  const mergedLabels = labelsWithLastLabelHighlighted.reduce(
    (acc, label, index) => {
      if (index > 0) {
        acc.push(
          <ChevronRightIcon
            key={`chevron-${index}`}
            size="medium"
            className={styles.chevronIcon}
          />,
        );
        acc.push(' ');
      }
      acc.push(<React.Fragment key={`label-${index}`}>{label}</React.Fragment>);
      return acc;
    },
    [],
  );

  return <span className={styles.navigationLabel}>{mergedLabels}</span>;
};

NavigationLabel.propTypes = {
  superTab: PropTypes.object.isRequired,
  sectionTab: PropTypes.object,
  subTab: PropTypes.object,
  searchString: PropTypes.string,
};
